import React from 'react'

import { useSelector } from 'react-redux'

import { useNumRecipesOverBasketLimit } from 'routes/Menu/domains/basket'
import { getIsOneThreeFivePortionsEnabled } from 'selectors/features'

import { Receipt } from './Receipt'

export const ReceiptWrapper = (ownProps: any) => {
  const numRecipesOverLimit = useNumRecipesOverBasketLimit()
  const isOneThreeFivePortionsEnabled = useSelector(getIsOneThreeFivePortionsEnabled)
  const numRecipesOverBasketLimit = !!numRecipesOverLimit

  return (
    <Receipt
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...ownProps}
      numRecipesOverBasketLimit={numRecipesOverBasketLimit}
      isOneThreeFivePortionsEnabled={isOneThreeFivePortionsEnabled}
    />
  )
}
